import { Outlet, useParams } from "react-router-dom";
import GlobalMessage from "../components/GlobalMessage";
import JourneyEnding from "../components/JourneyEnding";
import { PauseButton } from "../components/PauseButton";
import { PlanSync } from "../components/PlanSync";
import { ProgressSync } from "../components/ProgressSync";
import { ChatbotProvider } from "../contexts/ChatContext";
import { EventProvider } from "../contexts/EventContext";
import { NextStepProvider } from "../contexts/NextStepContext";
import { ViewProvider } from "../contexts/ViewContext";

function LearningJourneyEnvironment() {
    const { id } = useParams();

    return (
        <EventProvider>
            <GlobalMessage />
            <ViewProvider learningJourneyId={id}>
                <ProgressSync />
                <PlanSync />
                <PauseButton />
                <NextStepProvider>
                    <JourneyEnding />
                    <ChatbotProvider learningJourneyId={id}>
                        <Outlet />
                    </ChatbotProvider>
                </NextStepProvider>
            </ViewProvider>
        </EventProvider>
    );
}

export default LearningJourneyEnvironment;